
































import { Vue, Prop, Component } from "vue-property-decorator";
import { Agent as IAgent } from "@/api-v2/agent/models/agent";
import CustomTable from "@/components/form/CustomTable.vue";
import AgentTableItem from "@/components/agent/AgentTableItem.vue";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({
  components: { CustomButton, AgentTableItem, CustomTable }
})
export default class AgentTable extends Vue {
  @Prop({ default: () => [] }) agents!: IAgent[];
  @Prop({ default: 0 }) count!: number;

  get isShowAddMoreButton(): boolean {
    return this.agents?.length < (this.count ?? 0);
  }

  removeHandler(agent: IAgent) {
    this.$emit("remove", agent);
  }
}
